import request, { Methods, withToken } from "../../../../assets/util/request";

//* ACTIONTYPES --------------------------------------------
export const POST_INVOICE_PROVIDER_RESET = 'POST_INVOICE_PROVIDER_RESET';
export const POST_INVOICE_PROVIDER_LOADING = 'POST_INVOICE_PROVIDER_LOADING';
export const POST_INVOICE_PROVIDER_SUCCESS = 'POST_INVOICE_PROVIDER_SUCCESS';
export const POST_INVOICE_PROVIDER_REJECT = 'POST_INVOICE_PROVIDER_REJECT';

//* ACTIONS ------------------------------------------------
export const postInvoiceProviderReset = () => ({ type: POST_INVOICE_PROVIDER_RESET });
export const postInvoiceProviderLoading = () => ({ type: POST_INVOICE_PROVIDER_LOADING });
export const postInvoiceProviderSuccess = (payload) => ({ type: POST_INVOICE_PROVIDER_SUCCESS, payload });
export const postInvoiceProviderReject = (payload) => ({ type: POST_INVOICE_PROVIDER_REJECT, payload });

//* REQUEST SERVICE ---------------------------------------
export const postInvoiceProviderRequest = async (data, getState) => {
    const options = await withToken({
        method: Methods.POST,
        data,
    }, getState);
    return request(`/ProvidersBillingTracking/web/AddProvidersBillingTracking`, options);
};


